import { AdditionalInformation } from '@hivebrite/design-system/AdditionalInformation';
import { Box } from '@hivebrite/design-system/Box';

export const PaymentError = ({ errorMessage }) => (
  <Box mt={2}>
    <AdditionalInformation>
      {errorMessage ||
        s__('Touchnet|External bank declined your payment request')}
    </AdditionalInformation>
  </Box>
);
